import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4b6c02c2")

_pushScopeId("data-v-4b6c02c2")
const _hoisted_1 = /*#__PURE__*/_createVNode("svg", {
  "enable-background": "new 0 0 330 330",
  version: "1.1",
  viewBox: "0 0 330 330",
  "xml:space": "preserve",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createVNode("path", { d: "m165 0c-90.981 0-165 74.02-165 165s74.019 165 165 165 165-74.018 165-165-74.019-165-165-165zm0\n      300c-74.44 0-135-60.56-135-135s60.56-135 135-135 135 60.562 135 135-60.561 135-135 135z" }),
  /*#__PURE__*/_createVNode("path", { d: "m165 70c-11.026 0-19.996 8.976-19.996 20.009 0 11.023 8.97 19.991 19.996 19.991s19.996-8.968\n       19.996-19.991c0-11.033-8.97-20.009-19.996-20.009z" }),
  /*#__PURE__*/_createVNode("path", { d: "m165 140c-8.284 0-15 6.716-15 15v90c0 8.284 6.716 15 15 15s15-6.716 15-15v-90c0-8.284-6.716-15-15-15z" })
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Modal = _resolveComponent("Modal")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("a", {
      class: [_ctx.extraClasses, "info"],
      onClick: _cache[1] || (_cache[1] = $event => (_ctx.showing = true))
    }, [
      _hoisted_1
    ], 2),
    (_ctx.showing)
      ? (_openBlock(), _createBlock(_component_Modal, {
          key: 0,
          title: _ctx.title,
          onClose: _cache[2] || (_cache[2] = $event => (_ctx.showing = false))
        }, {
          default: _withId(() => [
            _renderSlot(_ctx.$slots, "default")
          ]),
          _: 3
        }, 8, ["title"]))
      : _createCommentVNode("", true)
  ], 64 /* STABLE_FRAGMENT */))
})